import { getAndApplyAdobeTargetOffers } from '@rei/adobe-target-functions';

const mapExperiences = (
  experiences,
  testName,
) => {
  const activities = experiences.offers;
  if (activities?.length && activities?.length > 0) {
    const result = activities.reduce((acc, item) => {
      if (!item) return acc;

      const key = item?.experimentName?.replace(/-/g, '');
      if (!key) return acc;
      
      acc[key] = item?.experience;

      return acc;
    }, {});

    if (testName && !result[testName]) throw new Error(`Experience ${testName} not found`);

    return testName ? result[testName] : result;
  }
  throw new Error('No experiences found');
};

const AdobeTarget = {
  /**
   * Provides an object with Adobe Target activity test name and its experience
   * @param {string} testName -
   * The Adobe Target experience test name to get the experience. EX. APEX123.
   * @returns {Promise<any>} an object with Adobe Target activity test name and its experience Ex: {"APEX123": "control"}
   */
  async get(testName) {
    try {
      if (!testName) {
        throw new Error('No options were provided');
      }

      const experiences = await getAndApplyAdobeTargetOffers({
          options: { mbox: 'target-global-mbox', timeout: 3000, scopes: ['__view__'] },
        });
      return mapExperiences(experiences, testName);

    } catch (error) {
      console.error(error);
      return null;
    }
  },
};

export default AdobeTarget;
